import { Component } from "react";
import Toolbar from "../components/toolbar";
import { MdAddBox } from "react-icons/md";
import { addDoc, collection, deleteDoc, Firestore, getDocs, orderBy, query, Timestamp, updateDoc } from "firebase/firestore/lite";
import { dbPublic } from "../../App";
import { FaEdit, FaTrash } from "react-icons/fa";
import { CgCloseO } from "react-icons/cg";
import { TiCancel } from "react-icons/ti";
import { ImCheckmark } from "react-icons/im";

class Puppies extends Component<any,any>{

    constructor(props:any)
    {
        super(props);
        this.state = {
            updating: false,
            litters: [],
            damepic: '',
            sirepic: '',
            litterPics: [],
            deletedPics: [],
            editing: false,
            litterDocRef: '',
            isSaving: false,
        }
    }

    async downloadDamePic(file:FileList) {
        var reader = new FileReader();
        reader.onload = async (e) => {
            //if (this.state.litterDoc != null) {
            //    this.state.litterDoc.damepic = e.target!.result as string;
            //}
            this.setState({damepic: e.target!.result as string, litterDoc: this.state.litterDoc});
        }
        reader.readAsDataURL(file[0]);
    }

    async downloadSirePic(file:FileList) {
        var reader = new FileReader();
        reader.onload = async (e) => {
            //if (this.state.litterDoc != null) {
            //    this.state.litterDoc.sirepic = e.target!.result as string;
            //}
            this.setState({sirepic: e.target!.result as string, litterDoc: this.state.litterDoc});
        }
        reader.readAsDataURL(file[0]);
    }

    async downloadLitterPics(files:FileList)
    {
        console.log(this.state.litterPics.length);
        for(var i=0; i<files.length; i++)
        {

            var x = new FileReader();
            x.onload = (a) => {
                
                var pic = {
                    description: '',
                    image: a.target?.result,
                    order: 0,
                }
                this.state.litterPics.push(pic)
                // if (this.state.litterDoc != null) {
                //     this.state.litterDoc.litterPics.push(pic);
                // }
                
                this.setState({litterPics: this.state.litterPics, litterDoc: this.state.litterDoc});
            }
            x.readAsDataURL(files[i]);
        }
       
    }

    async componentDidMount() {
            var tCol = collection(dbPublic,'litters');
            var tSnap = getDocs(query(tCol,orderBy("litterDate",'desc'))).then(tSnap => {
                this.setState({litters: tSnap.docs});
            });
        }

    render() {

        return(
            <div style={{height: '100%', fontFamily: 'avenir'}}>
                <Toolbar />
                <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                    PUPPIES / LITTERS
                </div>
                <div>
                    <div style={{fontFamily: 'avenirb'}}></div>
                    Add or edit upcoming litter dates for the website.<br/><br/>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                        this.setState({updating: true, sirepic: '', damepic: '', litterpics: []});
                    }}><MdAddBox style={{color: 'rgba(0,200,0,1)'}} size={30} /> NEW LITTER DATE</div>
                    <br/>
                </div>
                <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                    <div style={{width: '200px'}}><b>Date</b></div>
                    <div style={{width: '200px'}}><b>Dame</b></div>
                    <div style={{width: '200px'}}><b>Sire</b></div>
                    <div style={{width: '200px'}}></div>
                </div>
                {this.state.litters.map((litter:any, i:number)=>{
                    var l = litter.data();
                    return(
                        <div key={i} style={{fontSize: '10pt',display: 'flex',marginTop: '10px',paddingBottom: '10px',borderBottom: '1px solid rgba(0,0,0,.2)'}}>
                            <div style={{width: '200px'}}><b>{new Date(l.litterDate.seconds * 1000).toLocaleDateString(undefined,{
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}</b></div>
                            <div style={{width: '200px'}}><b>{l.dame}</b></div>
                            <div style={{width: '200px'}}><b>{l.sire}</b></div>
                            <div style={{width: '200px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                                <FaEdit size={25} style={{marginRight: '30px', cursor: 'pointer'}} onClick={()=>{
                                    var tCol = collection(dbPublic,'litters/' + litter.id + '/damePic');
                                    getDocs(tCol).then((docs)=>{
                                        console.log(litter.id,docs)
                                         var pics:any = [];
                                         var damepic = '';
                                         docs.docs.map((pic:any)=>{
                                             var p = pic.data();
                                             damepic = p.damepic;
                                             console.log(pic.id);
                                         })
                                         this.setState({damepic: damepic});
                                    })

                                    var tCol = collection(dbPublic,'litters/' + litter.id + '/sirePic');
                                    getDocs(tCol).then((docs)=>{
                                        console.log(litter.id,docs)
                                         var pics:any = [];
                                         var sirepic = '';
                                         docs.docs.map((pic:any)=>{
                                             var p = pic.data();
                                             sirepic = p.sirepic;
                                             console.log(pic.id);
                                         })
                                         this.setState({sirepic: sirepic});
                                    })

                                    var tCol = collection(dbPublic,'litters/' + litter.id + '/litterPics');
                                    getDocs(tCol).then((docs)=>{
                                        //console.log(litter.id,docs)
                                         var pics:any = [];
                                         //var damepic = '';
                                         docs.docs.map((pic:any)=>{
                                             var p = pic.data();
                                             //damepic = p.damepic;
                                             pics.push({image: p.image});
                                             //console.log(pic.id);
                                         })
                                         this.setState({litterPics: pics});
                                    })
                                    // tCol = collection(dbPublic,'dames/' + sire.id + '/CKCpictures');
                                    // getDocs(query(tCol,orderBy("order", 'asc'))).then((docs)=>{
                                    //     var pics:any = [];
                                    //     docs.docs.map((pic:any)=>{
                                    //         var p = pic.data();
                                    //         pics.push({image: p.image, id: pic.id, ref: pic.ref, description: p.description, order: p.order});
                                    //     })
                                    //     this.setState({sireCKCPics: pics});
                                    // })
                                    this.setState({editing: true, litterDoc: l, litterDocRef: litter.ref, litterDocID: litter.id});
                                }}/>
                                <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                    var tCol = collection(dbPublic,'litters');
                                    await deleteDoc(litter.ref);
                                    var tSnap = await getDocs(query(tCol,orderBy("litterDate",'desc')));
                                    this.setState({litters: tSnap.docs});
                                }}/>
                            </div>
                        </div>
                    )
                })}

                {this.state.updating ?
                    <div className="overlay" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div className="window" style={{height: 'auto', maxHeight: '500px',overflow: 'hidden'}}>
                            <div className="closeWindow" onClick={()=>{
                                this.setState({updating: false, testimonial: {}, testimonialDoc: {}});
                            }}>
                                <CgCloseO />
                            </div>
                            <div className="windowTitle">
                                ADD NEW LITTER
                            </div>
                            
                            <div>
                                Add a new litter or expected litter date.  When finished, click the save button to confirm.
                            </div>
                            <div className="formStyle" style={{position: 'relative',overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin', height: '300px', marginBottom: '150px',top: 0,}}>
                                <div className="label">
                                    Date
                                </div>
                                <div className="input" >
                                    <input type="datetime-local" required name="date" />
                                </div>
                                <div className="label">
                                    Dame (Mother)
                                </div>
                                <div className="input" >
                                    <input type="text" required name="dame" style={{width: '75%'}} />
                                </div>
                                <div className="label">
                                    Sire (Father)
                                </div>
                                <div className="input" style={{marginBottom: '20px'}}>
                                    <input type="text" required name="sire" style={{width: '75%'}} />
                                </div>
                                <div className="label">
                                    Short Description
                                </div>
                                <div className="input" style={{marginBottom: '20px'}}>
                                    <textarea name="description" style={{width: '75%'}} rows={3} />
                                </div>
                                <div style={{width: '100%', display: 'flex', justifyContent: 'flex-start',marginBottom: '20px'}}>
                                    <div style={{position: 'relative',width: '175px',marginRight: '20px', backgroundColor: 'rgba(150,89,89,.1)', justifyContent: 'center', alignItems: 'center', display: 'flex', border: '2px dashed rgb(150, 89, 89)', height: '175px'}} >
                                        Upload picture of Dame
                                        {this.state.damepic != '' ?
                                            <img src={this.state.damepic} style={{position: 'absolute', width: '175px', height: '175px', objectFit: 'cover'}} />
                                        : null}
                                        <input type="file" name="damepic" style={{position: 'absolute', left: 0, top: 0, height: '175px', width: '175px', opacity: 0, cursor: 'pointer'}} onChange={(e)=>{
                                            this.downloadDamePic(e.target.files!); 
                                        }}/>
                                        
                                    </div>
                                    <div style={{position: 'relative',width: '175px', backgroundColor: 'rgba(150,89,89,.1)', justifyContent: 'center', alignItems: 'center', display: 'flex', border: '2px dashed rgb(150, 89, 89)', height: '175px'}} >
                                        Upload picture of Sire
                                        {this.state.sirepic != '' ?
                                            <img src={this.state.sirepic} style={{position: 'absolute', width: '175px', height: '175px', objectFit: 'cover'}} />
                                        : null}
                                        <input type="file" name="sirepic" style={{position: 'absolute', left: 0, top: 0, height: '175px', width: '175px', opacity: 0, cursor: 'pointer'}} onChange={(e)=> {
                                            this.downloadSirePic(e.target.files!); 
                                        }}/>
                                    </div>
                                </div>
                                <div className="PictureBoxDD" style={{position: 'relative',width: '95%', border: '3px dashed rgba(0,0,0,.3)', backgroundColor: 'rgba(200,0,0,.3)'}} onDrop={(e)=>{
                                    e.preventDefault();
                                    
                                    //this.downloadPics(e.dataTransfer.files);
                                }} onDragOver={(e)=>{e.preventDefault();}} onDragEnter={(e)=>{e.preventDefault();}}>
                                    <div style={{width: '100%', height: '100%', padding: 30, display: 'flex'}}>Drag and drop pictures here or&nbsp;<br/><div style={{position: 'relative', textDecoration: 'underline', cursor: 'pointer'}}>click here <input type="file" multiple name="file" id="litterpics" style={{position: 'absolute', cursor: 'pointer', left: 0, top: 0, opacity: 0,  }} onChange={(e)=>{
                                        
                                        this.downloadLitterPics(e.target.files!); 
                                    }}/></div>&nbsp;to select images.
                                    
                                    </div>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(100px,1fr)', gap: 5, padding: 5,}}>
                                {this.state.litterPics.map((pic:any,idx:number)=>{
                                    var p = pic;
                                    
                                    return(
                                        <div key={idx} style={{position: 'relative'}}>
                                            <img src={p.image} style={{width: '100%', height: 'auto', borderRadius: '10px', cursor: 'pointer'}} onClick={()=>{
                                                //this.setState({UpdatingImageInfo: true, sireImage: {idx: idx, pic: p}});
                                            }}/><br/>
                                            <span style={{fontSize: '8pt'}}>{p.description}</span>
                                    
                                            <div style={{position: 'absolute', top: -5, right: -5, height: 20, width: 20, backgroundColor: 'black', color: 'white', borderRadius: 10, textAlign: 'center', fontSize: '12pt', fontFamily: 'avenirb', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                                                this.state.deletedPics.push(this.state.litterPics[idx]);
                                                this.state.litterPics.splice(idx,1);
                                                this.setState({sirePics: this.state.litterPics});
                                            }}><CgCloseO /></div>
                                        </div>
                                    )
                                })}
                                </div>
                            </div>
                            <div className="buttons">
                                <button className="cancelButton" onClick={()=>{
                                    this.setState({updating: false, testimonial: {}, testimonialDoc: {}});
                                }}><TiCancel /> CANCEL</button>
                                <button className="acceptButton" onClick={async ()=>{
                                        var tCol = collection(dbPublic,'litters');
                                        var ld = (document.getElementsByName("date")[0] as HTMLInputElement).value;
                                        var d = new Date(ld);
                                        console.log("DESCRIPTION:",(document.getElementsByName("description")[0] as HTMLTextAreaElement).value);
                                        var docRef = await addDoc(tCol,{
                                            
                                            litterDate: Timestamp.fromDate(d),
                                            dame: (document.getElementsByName("dame")[0] as HTMLInputElement).value,
                                            sire: (document.getElementsByName("sire")[0] as HTMLInputElement).value,
                                            description: (document.getElementsByName("description")[1] as HTMLTextAreaElement).value,
                                            });
                                        
                                        tCol = collection(dbPublic,'litters/' + docRef.id + '/damePic');
                                        getDocs(tCol).then(tSnap => {
                                            tSnap.docs.forEach(doc => {
                                                deleteDoc(doc.ref);
                                            });
                                        });
                                        await addDoc(tCol, {damepic: this.state.damepic});
                                        tCol = collection(dbPublic,'litters/' + docRef.id + '/sirePic');
                                        getDocs(tCol).then(tSnap => {
                                            tSnap.docs.forEach(doc => {
                                                deleteDoc(doc.ref);
                                            });
                                        })
                                        await addDoc(tCol, {sirepic: this.state.sirepic});
                                        tCol = collection(dbPublic,'litters/' + docRef.id + '/litterPics');
                                        getDocs(tCol).then(tSnap => {
                                            tSnap.docs.forEach(doc => {
                                                deleteDoc(doc.ref);
                                            });
                                        })
                                        for(var i = 0; i < this.state.litterPics.length; i++)
                                        {
                                            await addDoc(tCol, this.state.litterPics[i]);
                                        }
                                        tCol = collection(dbPublic,'litters/');
                                        
                                    
                                    var tSnap = await getDocs(query(tCol,orderBy("litterDate",'desc')));
                        
                                    this.setState({updating: false, litters: tSnap.docs});
                                }} ><ImCheckmark /> CONFIRM</button>
                            </div>
                        </div>
                    </div> : null}

                    {this.state.editing ?
                    <div className="overlay" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div className="window" style={{height: 'auto', maxHeight: '500px',overflow: 'hidden'}}>
                            <div className="closeWindow" onClick={()=>{
                                this.setState({editing: false, testimonial: {}, litterDoc: {}});
                            }}>
                                <CgCloseO />
                            </div>
                            <div className="windowTitle">
                                EDIT LITTER
                            </div>
                            
                            <div>
                                Add a new litter or expected litter date.  When finished, click the save button to confirm.
                            </div>
                            <div className="formStyle" style={{position: 'relative',overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin', height: '300px', marginBottom: '150px',top: 0,}}>
                                <div className="label">
                                    Date
                                </div>
                                <div className="input" >
                                    <input type="datetime-local" required defaultValue={new Date(this.state.litterDoc.litterDate.seconds * 1000 - ((1000 * 60) * (new Date().getTimezoneOffset() + 60))).toISOString().replace("Z","")} name="date1" />
                                </div>
                                <div className="label">
                                    Dame (Mother)
                                </div>
                                <div className="input" >
                                    <input type="text"  required name="dame1" defaultValue={this.state.litterDoc.dame} style={{width: '75%'}} />
                                </div>
                                <div className="label">
                                    Sire (Father)
                                </div>
                                <div className="input" style={{marginBottom: '20px'}}>
                                    <input type="text"  required name="sire1" defaultValue={this.state.litterDoc.sire} style={{width: '75%'}} />
                                </div>
                                <div className="label">
                                    Short Description
                                </div>
                                <div className="input" style={{marginBottom: '20px'}}>
                                    <textarea name="description1" defaultValue={this.state.litterDoc.description} style={{width: '75%'}} rows={3} />
                                </div>
                                <div style={{width: '100%', display: 'flex', justifyContent: 'flex-start',marginBottom: '20px'}}>
                                    <div style={{position: 'relative',width: '175px',marginRight: '20px', backgroundColor: 'rgba(150,89,89,.1)', justifyContent: 'center', alignItems: 'center', display: 'flex', border: '2px dashed rgb(150, 89, 89)', height: '175px'}} >
                                        Upload picture of Dame
                                        {this.state.damepic != '' ?
                                            <img src={this.state.damepic} style={{position: 'absolute', width: '175px', height: '175px', objectFit: 'cover'}} />
                                        : null}
                                        <input type="file" name="damepic" style={{position: 'absolute', left: 0, top: 0, height: '175px', width: '175px', opacity: 0, cursor: 'pointer'}} onChange={(e)=>{
                                            this.downloadDamePic(e.target.files!); 
                                        }}/>
                                        
                                    </div>
                                    <div style={{position: 'relative',width: '175px', backgroundColor: 'rgba(150,89,89,.1)', justifyContent: 'center', alignItems: 'center', display: 'flex', border: '2px dashed rgb(150, 89, 89)', height: '175px'}} >
                                        Upload picture of Sire
                                        {this.state.sirepic != '' ?
                                            <img src={this.state.sirepic} style={{position: 'absolute', width: '175px', height: '175px', objectFit: 'cover'}} />
                                        : null}
                                        <input type="file" name="sirepic" style={{position: 'absolute', left: 0, top: 0, height: '175px', width: '175px', opacity: 0, cursor: 'pointer'}} onChange={(e)=> {
                                            this.downloadSirePic(e.target.files!); 
                                        }}/>
                                    </div>
                                </div>
                                <div className="PictureBoxDD" style={{position: 'relative',width: '95%', border: '3px dashed rgba(0,0,0,.3)', backgroundColor: 'rgba(200,0,0,.3)'}} onDrop={(e)=>{
                                    e.preventDefault();
                                    
                                    //this.downloadPics(e.dataTransfer.files);
                                }} onDragOver={(e)=>{e.preventDefault();}} onDragEnter={(e)=>{e.preventDefault();}}>
                                    <div style={{width: '100%', height: '100%', padding: 30, display: 'flex'}}>Drag and drop pictures here or&nbsp;<br/><div style={{position: 'relative', textDecoration: 'underline', cursor: 'pointer'}}>click here <input type="file" multiple name="file" id="litterpics" style={{position: 'absolute', cursor: 'pointer', left: 0, top: 0, opacity: 0,  }} onChange={(e)=>{
                                        
                                        this.downloadLitterPics(e.target.files!); 
                                    }}/></div>&nbsp;to select images.
                                    
                                    </div>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(100px,1fr)', gap: 5, padding: 5,}}>
                                {this.state.litterPics.map((pic:any,idx:number)=>{
                                    var p = pic;
                                    
                                    return(
                                        <div key={idx} style={{position: 'relative'}}>
                                            <img src={p.image} style={{width: '100%', height: 'auto', borderRadius: '10px', cursor: 'pointer'}} onClick={()=>{
                                                //this.setState({UpdatingImageInfo: true, sireImage: {idx: idx, pic: p}});
                                            }}/><br/>
                                            <span style={{fontSize: '8pt'}}>{p.description}</span>
                                    
                                            <div style={{position: 'absolute', top: -5, right: -5, height: 20, width: 20, backgroundColor: 'black', color: 'white', borderRadius: 10, textAlign: 'center', fontSize: '12pt', fontFamily: 'avenirb', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                                                this.state.deletedPics.push(this.state.litterPics[idx]);
                                                this.state.litterPics.splice(idx,1);
                                                //this.state.litterDoc.litterPics.splice(idx,1);
                                                this.setState({litterPics: this.state.litterPics,litterDoc: this.state.litterDoc});
                                            }}><CgCloseO /></div>
                                        </div>
                                    )
                                })}
                                </div>
                            </div>
                            <div className="buttons">
                                <button className="cancelButton" onClick={()=>{
                                    this.setState({editing: false, testimonial: {}, litterDoc: {}});
                                }}><TiCancel /> CANCEL</button>
                                <button className="acceptButton" onClick={async ()=>{
                                       this.setState({isSaving: true});
                                        var tCol = collection(dbPublic,'litters');
                                        var ld = (document.getElementsByName("date1")[0] as HTMLInputElement).value;
                                        var d = new Date(ld);
                                        await updateDoc(this.state.litterDocRef,{
                                            
                                            litterDate: Timestamp.fromDate(d),
                                            dame: (document.getElementsByName("dame1")[0] as HTMLInputElement).value,
                                            sire: (document.getElementsByName("sire1")[0] as HTMLInputElement).value,
                                            description: (document.getElementsByName("description1")[0] as HTMLInputElement).value,
                                            //damepic: this.state.damepic,
                                            //sirepic: this.state.sirepic,
                                            //litterPics: this.state.litterPics,
                                            });
                                        //await updateDoc(this.state.litterDocRef,this.state.litterDoc);
                                    
                                        tCol = collection(dbPublic,'litters/' + this.state.litterDocID + '/damePic');
                                        getDocs(tCol).then(tSnap => {
                                            tSnap.docs.forEach(doc => {
                                                deleteDoc(doc.ref);
                                            });
                                        });
                                        await addDoc(tCol, {damepic: this.state.damepic});
                                        tCol = collection(dbPublic,'litters/' + this.state.litterDocID + '/sirePic');
                                        getDocs(tCol).then(tSnap => {
                                            tSnap.docs.forEach(doc => {
                                                deleteDoc(doc.ref);
                                            });
                                        })
                                        await addDoc(tCol, {sirepic: this.state.sirepic});
                                        tCol = collection(dbPublic,'litters/' + this.state.litterDocID + '/litterPics');
                                        getDocs(tCol).then(tSnap => {
                                            tSnap.docs.forEach(doc => {
                                                deleteDoc(doc.ref);
                                            });
                                        })
                                        for(var i = 0; i < this.state.litterPics.length; i++)
                                        {
                                            await addDoc(tCol, this.state.litterPics[i]);
                                        }
                                        tCol = collection(dbPublic,'litters');
                                    var tSnap = await getDocs(query(tCol,orderBy("litterDate",'desc')));
                        
                                    this.setState({editing: false, litters: tSnap.docs, isSaving: false});
                                }} ><ImCheckmark /> CONFIRM</button>
                            </div>
                        </div>
                    </div> : null}
                </section>
                {this.state.isSaving ?
            <div style={{position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.8)', justifyContent: 'center', alignItems: 'center', display: 'flex', zIndex: 12000}}>
                <div style={{width: '80%', textAlign: 'center', color: '#fff'}}>
                    SAVING...
                    <progress style={{width: '100%', height: '10px'}}></progress>
                </div>
            </div> : null}
            </div>
            )
    }

}

export default Puppies;